// extracted by mini-css-extract-plugin
module.exports = {"TopCharts":"StudentTracking_TopCharts__fzmyF","StudentTracking":"StudentTracking_StudentTracking__3giFU"};